import { render, staticRenderFns } from "./DashboardNumeric.vue?vue&type=template&id=21d1ec26&scoped=true&"
import script from "./DashboardNumeric.vue?vue&type=script&lang=js&"
export * from "./DashboardNumeric.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNumeric.vue?vue&type=style&index=0&id=21d1ec26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1ec26",
  null
  
)

export default component.exports